import React, { useState } from "react";

export const StoreInfo = () => {
  return (
    <div>
      <h2>Store Info</h2>
    </div>
  );
};

export default StoreInfo;
